'use client';

import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

interface ScrollToTopButtonProps {
  className?: string;
}

const ScrollToTopButton: React.FC<ScrollToTopButtonProps> = ({ className }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const scrollTop = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercentage = (scrollTop / documentHeight) * 100;

      setIsVisible(scrollPercentage > 35);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div
      className={`fixed bottom-3 right-3 z-50 transition-opacity duration-300 md:bottom-6 md:right-6 ${
        isVisible ? 'opacity-100' : 'pointer-events-none opacity-0'
      }`}
    >
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className={` flex items-center justify-center rounded-full border border-white bg-blue-600 p-3 shadow-lg transition-colors duration-200 hover:bg-blue-700 ${className}`}
      >
        <ChevronUp className="size-5 text-white" />
      </button>
    </div>
  );
};

export default ScrollToTopButton;
